import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import SMSCampaignsPage from './pages/SMSCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
// NOTICE: KAPTION-INTEGRATION
import WhatsAppCampaignReportPage from './pages/WhatsAppCampaignReportPage.vue';
import KaptionWhatsAppCampaignBuilderPage from './pages/KaptionWhatsAppCampaignBuilderPage.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
import WhatsAppTemplatesPage from './pages/WhatsAppTemplatesPage.vue';
import WhatsAppTemplateCreatePage from './pages/WhatsAppTemplateCreatePage.vue';
import KaptionWhatsAppPreviewTest from './pages/KaptionWhatsAppPreviewTest.vue';
import KaptionInlineEditorTest from './pages/KaptionInlineEditorTest.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send
import KaptionDirectPage from './pages/KaptionDirectPage.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send form page
import KaptionDirectSendPage from './pages/KaptionDirectSendPage.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send detail page
import KaptionDirectDetailPage from './pages/KaptionDirectDetailPage.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send report page
import KaptionDirectReportPage from './pages/KaptionDirectReportPage.vue';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send campaign creation
import KaptionDirectCreatePage from './pages/KaptionDirectCreatePage.vue';
// NOTICE: KAPTION-INTEGRATION - Aggregate Campaign Reports dashboard
import CampaignReportsPage from './pages/CampaignReportsPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        // NOTICE: KAPTION-INTEGRATION - Default to WhatsApp campaigns
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_whatsapp_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_whatsapp_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_whatsapp_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        // NOTICE: KAPTION-INTEGRATION - Aggregate Campaign Reports dashboard
        // (in-component gate on the KAPTION_CAMPAIGN_REPORTS feature flag)
        {
          path: 'reports',
          name: 'campaigns_reports_index',
          meta,
          component: CampaignReportsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          component: SMSCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
        {
          path: 'whatsapp/templates',
          name: 'campaigns_whatsapp_templates',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppTemplatesPage,
        },
        {
          path: 'whatsapp/templates/new',
          name: 'campaigns_whatsapp_templates_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppTemplateCreatePage,
        },
        // NOTICE: KAPTION-INTEGRATION
        {
          path: 'whatsapp/:campaignId/report',
          name: 'campaigns_whatsapp_report',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignReportPage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send
        {
          path: 'direct',
          name: 'campaigns_direct_index',
          meta,
          component: KaptionDirectPage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send campaign creation
        {
          path: 'direct/create',
          name: 'campaigns_direct_create',
          meta,
          component: KaptionDirectCreatePage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send form page
        {
          path: 'direct/new',
          name: 'campaigns_direct_send',
          meta,
          component: KaptionDirectSendPage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send report page
        {
          path: 'direct/:directId/report',
          name: 'campaigns_direct_report',
          meta,
          component: KaptionDirectReportPage,
        },
        // NOTICE: KAPTION-INTEGRATION - WhatsApp Direct Send detail page
        {
          path: 'direct/:directId',
          name: 'campaigns_direct_detail',
          meta,
          component: KaptionDirectDetailPage,
        },
        // NOTICE: KAPTION-INTEGRATION - Full-page campaign builder
        {
          path: 'whatsapp/new',
          name: 'campaigns_whatsapp_new',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: KaptionWhatsAppCampaignBuilderPage,
        },
        // NOTICE: KAPTION-INTEGRATION - Test page for WhatsApp preview (dev only)
        {
          path: 'whatsapp/preview-test',
          name: 'campaigns_whatsapp_preview_test',
          meta,
          component: KaptionWhatsAppPreviewTest,
        },
        // NOTICE: KAPTION-INTEGRATION - Test page for inline editor (dev only)
        {
          path: 'whatsapp/editor-test',
          name: 'campaigns_whatsapp_editor_test',
          meta,
          component: KaptionInlineEditorTest,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
